module.exports = __webpack_public_path__ + "static/media/CTLA_4-135w.5bd12934.jpg";